import { fetchSearchResultsFailure } from 'store/search/searchActions';
import { getQueryParams } from 'store/router/routerSelectors';
import { getPageFromState } from './helpers';
import { createSearchErrorEvent } from '../eventCreators';
import { createSearchErrorEventPayload } from '../dataHelpers/createSearchErrorEventPayload';

const emitFetchSearchResultsFailureEvent = (action, prevState) => {
  const errors = [
    {
      code: action.payload.httpStatus,
      message: action.payload.message,
      name: action.payload.message,
    },
  ];
  const page = getPageFromState(prevState);

  const pageType = page.name === 'QH Map Page' ? 'map search' : 'list search';

  const queryParams = getQueryParams(prevState);
  const searchTerm = queryParams && queryParams.location ? queryParams.location : '';
  const currentUrl = window.location.href;

  const searchErrorEvent = createSearchErrorEvent(
    createSearchErrorEventPayload({
      errors,
      searchTerm,
      pageType,
      url: currentUrl,
    }),
  );

  return searchErrorEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [fetchSearchResultsFailure]: emitFetchSearchResultsFailureEvent };
